import api from './api';
import { ENTITY_MODAL_NAMES } from '../pages/tracking/tracking-page.format';

/** Media buyers may edit flows, offers, networks and landers; traffic sources are admin-only (their PATCH routes). */
export function canEditNotes(groupBy: string, role: string | undefined): boolean {
  if (!ENTITY_MODAL_NAMES[groupBy]) return false;
  if (role === 'admin') return true;
  return role === 'media_buyer' && groupBy !== 'traffic_source_id';
}

export async function saveEntityNotes(groupBy: string, id: string, notes: string | null): Promise<void> {
  await api.patch(`/${ENTITY_MODAL_NAMES[groupBy]}s/${id}`, { notes });
}
